import { combineReducers } from "redux-immutable";
import { builderReducer } from "./builder";

export default combineReducers({
	builder: builderReducer
});
